var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group mt-2 mb-4" }, [
    _c("div", { staticClass: "mb-4" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "iiko_actions" } },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.__t("DISCOUNT_PROGRAM")) +
              "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.syrve_actions.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    label: "name",
                    reduce: function (action) {
                      return action.id
                    },
                    id: "iiko_actions",
                    options: this.syrve_actions,
                    filterable: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _c("div", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.name) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(option.id) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1670482459
                  ),
                  model: {
                    value: _vm.org_discount_program,
                    callback: function ($$v) {
                      _vm.org_discount_program = $$v
                    },
                    expression: "org_discount_program",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("CHOICE_SYRVE_ACTION")) +
                        "\n                "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }